import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCategories } from "../../../hooks/categoriesHooks/useCategories";
import { FaUserCircle } from "react-icons/fa";
import { MdAccountBox } from "react-icons/md";
import { BiLogOutCircle } from "react-icons/bi";

const MobileNavMenu = () => {
  const user = JSON.parse(localStorage.getItem("token"))?.user;
  const { data: categories, isLoading } = useCategories();
  const { i18n, t } = useTranslation();

  const changeLanguageTrigger = (e) => {
    const languageCode = e;
    i18n.changeLanguage(languageCode);
  };

  return (
    <nav className="offcanvas-navigation mb-0" id="offcanvas-navigation">
      {user && (
        <div className="d-flex justify-content-center align-items-center flex-column gap-2 mb-3 bg-gray rounded-3 p-4">
          {user.profile_picture ? (
            <img
              src={
                !user.profile_picture
                  ? "/assets/user-alt-1-svgrepo-com.svg"
                  : `${import.meta.env.VITE_REACT_APP_API_URL}/${
                      user.profile_picture
                    }`
              }
              alt="profile"
              className="rounded-circle object-fit-cover"
              width={"60px"}
              height={"60px"}
            />
          ) : (
            <FaUserCircle size={60} />
          )}
          <h6>{user?.name}</h6>
          <Link
            to="/my-account"
            className="d-flex align-items-center justify-content-start gap-2 border py-1 px-2 border-black rounded-1 bg-black text-white w-100"
          >
            <MdAccountBox size={24} />
            <p className="text-white mb-0">{t("my_account")}</p>
          </Link>
          <Link
            to=""
            onClick={() => {
              localStorage.removeItem("token");
              localStorage.removeItem("tokenExpiryTime");
              window.location.href = "/";
            }}
            className="d-flex align-items-center justify-content-start gap-2 border py-1 px-2 border-black rounded-1 bg-black text-white w-100"
          >
            <BiLogOutCircle size={24} />
            <p className="text-white mb-0">{t("logout")}</p>
          </Link>
        </div>
      )}
      <ul>
        <li>
          <NavLink to={"/"}>{t("home")}</NavLink>
        </li>

        <li>
          <NavLink to={"/shop"}>{t("shop")}</NavLink>
        </li>
        <li className="menu-item-has-children">
          <NavLink to={"/category"}>{t("categories")}</NavLink>
          <ul className="sub-menu m-0">
            {categories
              ?.filter((c) => !c.parent_id)
              ?.map((category, key) => (
                <li key={key}>
                  <Link
                    to={`/category/${category.id}`}
                    className="d-flex align-items-center gap-2"
                  >
                    <img
                      src={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                        category.img
                      }`}
                      alt="category_thumb"
                      loading="lazy"
                      className="object-fit rounded-circle"
                      width={"50px"}
                      height={"50px"}
                    />
                    <p style={{ textAlign: "start" }}>
                      {" "}
                      {i18n?.language === "ar"
                        ? category?.name
                        : category?.name_en}
                    </p>
                  </Link>
                </li>
              ))}
          </ul>
        </li>
        <li>
          <NavLink to={"/about"}>{t("about")}</NavLink>
        </li>
        <li>
          <NavLink to={"/contact"}>{t("contact")}</NavLink>
        </li>
        {!user && (
          <li>
            <NavLink to={"/login-register"}>{t("login")}</NavLink>
          </li>
        )}
      </ul>
      <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
        <button
          className={`btn ${
            i18n.language === "ar" ? "text-danger fw-medium border-danger" : ""
          }`}
          onClick={(e) => changeLanguageTrigger("ar")}
        >
          العربية
        </button>
        <button
          className={`btn ${
            i18n.language === "en" ? "text-danger fw-medium border-danger" : ""
          }`}
          onClick={(e) => changeLanguageTrigger("en")}
        >
          English
        </button>
      </div>
    </nav>
  );
};

export default MobileNavMenu;
